/**
 * @generated SignedSource<<da87d88a3f75e75cecde6c1405ab2d57>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type endRentalPageOpenMutation$variables = {
  id: string;
};
export type endRentalPageOpenMutation$data = {
  readonly utilizationGrantUse: {
    readonly id: string;
    readonly unlockRequest: {
      readonly id: string;
    };
  };
};
export type endRentalPageOpenMutation = {
  response: endRentalPageOpenMutation$data;
  variables: endRentalPageOpenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "GrantUnlock",
    "kind": "LinkedField",
    "name": "utilizationGrantUse",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UnlockRequest",
        "kind": "LinkedField",
        "name": "unlockRequest",
        "plural": false,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "endRentalPageOpenMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "endRentalPageOpenMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "931645dbed682be1f31503135b452f74",
    "id": null,
    "metadata": {},
    "name": "endRentalPageOpenMutation",
    "operationKind": "mutation",
    "text": "mutation endRentalPageOpenMutation(\n  $id: UUID!\n) {\n  utilizationGrantUse(id: $id) {\n    id\n    unlockRequest {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f95a676632dd6a43ae9a9c835c996b34";

export default node;
